import React from "react";

type Props = {
  title: string;
  value: string | number;
  suffix?: string;
  loading?: boolean;
  rightIcon?: any;
  rightIconSrc?: string;
  rightIconBgClassName?: string;
  rightIconColorClassName?: string;
};

/**
 * Minimal KPI card for the new researcher dashboard.
 * Title on top, large value below. Clean white card with subtle shadow.
 */
const StatsCard: React.FC<Props> = ({
  title,
  value,
  suffix,
  loading = false,
  rightIcon,
  rightIconSrc,
  rightIconBgClassName,
  rightIconColorClassName
}) => {
  const RightIcon = rightIcon;
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="mb-3 text-sm font-medium text-gray-500">{title}</p>
          {loading ? (
            <div className="mt-1 flex items-baseline">
              <div className="h-8 w-24 animate-pulse rounded-md bg-gray-200" />
            </div>
          ) : (
            <p className="text-3xl font-extrabold text-[#0B1739] md:text-4xl">
              {value}
              {suffix ? (
                <span className="ml-2 text-2xl font-semibold text-[#0B1739]">{suffix}</span>
              ) : null}
            </p>
          )}
        </div>
        {RightIcon || rightIconSrc ? (
          <div
            className={`ml-4 flex h-12 w-12 items-center justify-center rounded-full ${
              rightIconBgClassName || "bg-gray-100"
            }`}
          >
            {RightIcon ? (
              <RightIcon
                className={`h-6 w-6 ${rightIconColorClassName || "text-gray-500"}`}
              />
            ) : (
              <img src={rightIconSrc as string} alt="" className="h-6 w-6" />
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default StatsCard;


